module.exports = __webpack_public_path__ + "static/ma-4-sq-107923e3e8885bf21305ee766e3ec5a4.png";